import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Card, Typography } from "@mui/material";

interface ServiceCardProps {
  title: string;
}

const ServiceCard = ({ title }: ServiceCardProps) => {
  return (
    <Card
      sx={{
        height: "186px",
        bgcolor: "#ffecd9",
        borderRadius: "5.55px",
        border: "0.93px solid",
        borderColor: "primary.main",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: "33px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 700,
          fontSize: "24px",
          color: "text.primary",
          lineHeight: "30px",
        }}
      >
        {title}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <ArrowForwardIcon sx={{ width: "36px", height: "36px" }} />
      </Box>
    </Card>
  );
};

export default ServiceCard;
